import ProposalSummary from "../../Pages/ProposalSummary";



const navigation = {
    header: "Proposal Summary",
    links: [
      {
        text: "Proposal Summary",
        icon: <></>,
        route: "",
        component: ProposalSummary,
      },
    ],
  };
export default navigation;
